export class User {
    uid: string;
    name: string;
    email: string;
    password: string;
    accessToken: string;
    photoURL: string;
}

export enum Profile {
    admin = 'Administrador',
    iganhei = 'i-Ganhei'
}



// WEBPACK FOOTER //
// ./src/app/model/user.ts